// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"157":"24c36f56","455":"5b3c4187","461":"1df122c6","889":"950a9f5d","943":"60df93f4","977":"8584739d","994":"18009056"}[chunkId] + ".chunk.js";
};